import React, { useContext } from 'react'
import { MyContext } from '../../../../context/createContext'
import HandleOperation from './helpers/operations'
import ActionButton from './OperationButton'
import { ColFlexDiv } from './OperationButtonStyles'
interface Operation_props {
  stake: string
  tofix: number
  margin: string
  handleNotification: any
  handleStake: (s: string, name: string) => void
  currency: string
  audio: any
}

export default function Operations({
  stake,
  tofix,
  handleStake,
  margin,
  handleNotification,
  currency,
  audio,
}: Operation_props) {
  const { context } = useContext(MyContext)
  const {
    handleBaseStake,
    config: { minbet, maxbet },
  } = context
  return (
    <ColFlexDiv margin={margin}>
      <ActionButton
        text='1/2'
        width='23px'
        height='23px'
        bg='blue'
        fontSize='10.5417px'
        margin={'0px 8px 0px 0px'}
        func={() =>
          HandleOperation(
            stake,
            '1/2',
            tofix,
            minbet,
            maxbet,
            handleStake,
            handleNotification,
            currency,
            audio,
            handleBaseStake,
          )
        }
      />
      <ActionButton
        text='2x'
        width='23px'
        height='23px'
        bg='red'
        fontSize='10.5417px'
        margin={'0px 8px 0px 0px'}
        func={() =>
          HandleOperation(
            stake,
            '2x',
            tofix,
            minbet,
            maxbet,
            handleStake,
            handleNotification,
            currency,
            audio,
            handleBaseStake,
          )
        }
      />
    </ColFlexDiv>
  )
}
